import { render, staticRenderFns } from "./PaymentAttributeDetailList.vue?vue&type=template&id=3c05229b"
import script from "../../controllers/payment_att_detail/payment-attribute-detail-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_att_detail/payment-attribute-detail-list.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeDetailList.vue?vue&type=style&index=0&id=3c05229b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports